<div class="flex-column height-100 bg-col-w"
     [style]="client.isS || client.isM ? 'border-top-left-radius: 12px; border-top-right-radius: 12px;' : ''">
    <div class="p-a-4-s p-a-4-m p-a-5-l p-a-5-x b-b b-col-5">
        <div class="flex flex-justify-between">
            <div class="flex flex-middle">
                <p class="h3"
                   *iCms="'modalTitle' of content"></p>
            </div>
            <button role="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>



    <!-- content -->
    <div class="overflow-auto custom-scrollbar flex-grow p-l-5 p-r-5 p-l-4-s p-r-4-s p-l-4-m p-r-4-m">
        <product-view-calculator [component]="content"
                                 [preselectFirst]="true"
                                 [productsIds]="productsIds"></product-view-calculator>

    </div>
</div>